export default "__VITE_ASSET__DUyxDi9S__"